import React from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Grid, Theme } from '@mui/material'
import Delete from '@mui/icons-material/Delete'
import VisibilityRounded from '@mui/icons-material/VisibilityRounded'
import { makeStyles } from '@mui/styles'

import ButtonComponent from './ButtonComponent'
import ImageComponent from './ImageComponent'
import LightBox from './LightBox'
import VideoComponent from './VideoComponent'
import { PreviewFormat } from '@professocial/professocialTypes/types/commonTypes'
import PlayCircleFilledRounded from '@mui/icons-material/PlayCircleFilledRounded'

interface IProps {
  src: string | undefined
  view?: string
  previewFormat?: PreviewFormat
  type?: 'image' | 'video' | undefined
  deleteMediaFile?: () => void
  showAsPopUp?: boolean
}

const MediaUploadPreview: React.FC<IProps> = (props) => {
  const isViewRow = props.view === 'row'
  const previewFormat = props.previewFormat || PreviewFormat.square

  const useStyles = makeStyles((theme: Theme) => ({
    button: {
      fontWeight: 700,
      textTransform: 'initial',
      padding: '4px 8px',
      marginRight: isViewRow ? '20px' : 0,
      justifyContent: props.showAsPopUp ? 'center' : 'left',
    },
    image: {
      position: 'relative',
      objectFit: 'cover',
      height: previewFormat === PreviewFormat.square ? '105px' : '120px',
      width: isViewRow ? (previewFormat === PreviewFormat.square ? '105px' : 'auto') : '100%',
      zIndex: 0,
    },
    video: {
      position: 'relative',
      objectFit: 'cover',
      height: previewFormat === PreviewFormat.square ? '105px' : '120px',
      width: isViewRow ? (previewFormat === PreviewFormat.square ? '105px' : 'auto') : '100%',
      zIndex: 0,
    },
    fileBlock: {
      display: 'flex',
      position: 'relative',
      flexDirection: isViewRow ? 'row' : 'column',
      justifyContent: 'flex-start',
      minWidth: '200px'
    },
    imageProperties: {
      display: 'flex',
      flexDirection: isViewRow ? 'column' : 'row',
      justifyContent: 'center',
      marginLeft: isViewRow ? theme.spacing(2.5) : 0,
      alignSelf: isViewRow ? 'auto' : 'center'
    },
    typeIcon: {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      height: previewFormat === PreviewFormat.square ? '105px' : '120px',
      width: isViewRow ? (previewFormat === PreviewFormat.square ? '105px' : 'auto') : '100%',
      top: 0,
      left: 0,
      zIndex: 1,
      '& svg': {
        margin: '8px',
      },
    },
  }))

  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Box className={classes.fileBlock}>
      {props.src && (props.type === 'image' || props.type === undefined) &&
        <ImageComponent src={props.src} fallback='/src/shared/assets/images/icon-img-placeholder.svg' className={classes.image} alt='' />}
      {props.src && props.type === 'video' && (
        <>
          <div className={classes.typeIcon}>
            <PlayCircleFilledRounded style={{ color: '#fff', filter: 'drop-shadow( 0px 0px 3px rgba(0, 0, 0, .5))' }} />
          </div>
          <VideoComponent className={classes.video} fallbackThumb={undefined} src={props.src} />
        </>
      )}
      <Box className={classes.imageProperties}>
        <Grid container spacing={2} alignItems='flex-start'>
          {isViewRow
            ? (
              <Grid item xs={12}>
                <LightBox src={props.type !== 'video' ? props.src : undefined} videoSrc={props.type === 'video' ? props.src : undefined} disabled={!props.src}>
                  <ButtonComponent
                    className={classes.button}
                    startIcon={<VisibilityRounded />}
                    variant='text'
                    color='info'
                    disabled={!props.src}
                    text={t('postingCommon:preview')}
                    fullWidth
                  />
                </LightBox>
              </Grid>
            ) : null}
          {props.deleteMediaFile &&
            <Grid item xs={12}>
              <ButtonComponent
                className={classes.button}
                variant='text'
                color='info'
                onClick={props.deleteMediaFile && props.deleteMediaFile}
                startIcon={<Delete />}
                disabled={!props.src && isViewRow}
                text={t(isViewRow ? 'postingCommon:deleteMediaFile' : 'postingCommon:deleteLink')}
                fullWidth
              />
            </Grid>}
        </Grid>

      </Box>
    </Box>

  )
}

export default MediaUploadPreview
